// @owners { team: patients-team }
import {
  InstructionalVideosEndpoint,
  type InstructionalVideosEndpointFetchAllRequest,
  type InstructionalVideosEndpointFetchAllResponse,
} from '@alto/scriptdash/alto/patient_app/instructional_videos/v1/instructional_videos_endpoint';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { apiEndpointHandler } from '~shared/helpers/api';
import { getErrorMessageFromResponse } from '~shared/helpers/helper';
const instructionalVideosEndpoint = InstructionalVideosEndpoint(apiEndpointHandler);

export const instructionalVideos = createQueryKeys('instructionalVideos', {
  fetchAll: (params: InstructionalVideosEndpointFetchAllRequest) => ({
    queryKey: ['fetch-all-instructional-videos'],
    queryFn: async (): Promise<InstructionalVideosEndpointFetchAllResponse> => {
      const response = await instructionalVideosEndpoint.fetchAll(params);
      if (response.errors) {
        throw new Error(getErrorMessageFromResponse({ errors: response.errors }));
      }
      return response;
    },
  }),
});
